
const config = {
    publicUrl: process.env.PUBLIC_URL
}

export default config